document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".image-with-accordion-extended");
  if (!section) return;

  const faqQuestions = section.querySelectorAll(".faq-question");

  faqQuestions.forEach((question) => {
    question.addEventListener("click", function () {
      const currentItem = this.closest(".faq-item");
      const currentAnswer = currentItem.querySelector(".faq-answer");
      const isActive = currentItem.classList.contains("active");

      section.querySelectorAll(".faq-item").forEach((item) => {
        item.classList.remove("active");
        item.querySelector(".faq-answer").style.display = "none";
      });

      if (!isActive) {
        currentItem.classList.add("active");
        currentAnswer.style.display = "block";
      }
    });
  });
});
